export default __webpack_public_path__ + "static/media/rydz-login-new-image.0b63d2d9.png";